import React, { useState } from 'react'
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { formatRupiah } from '../../../Components/Global';
import { useEffect } from 'react';
import SearchInput from '../../../Components/SearchInput';
import { encrypt } from '../../../Utils/CryptoHelper';

const TableInvoice = ({ dataSource }) => {

    const columns = [
        {
            title: 'Invoice Number',
            dataIndex: 'InvoiceCode',
            key: 'InvoiceNumber',
            sorter: (a, b) => a.InvoiceNumber.localeCompare(b.InvoiceNumber),
            render: (value, record) => <Link to={`/dashboard/invoice/${encodeURIComponent(encrypt(record.AccountId))}/${encodeURIComponent(encrypt(value))}`} className="text-second hover:text-second-600 font-medium">{value}</Link>,
        },
        {
            title: 'Invoice Date',
            dataIndex: 'InvoiceDate',
            key: 'InvoiceDate',
            sorter: (a, b) => new Date(a.InvoiceDate) - new Date(b.InvoiceDate),
        },
        {
            title: 'Invoice Due Date',
            dataIndex: 'InvoiceDueDate',
            key: 'InvoiceDueDate',
            sorter: (a, b) => new Date(a.InvoiceDueDate) - new Date(b.InvoiceDueDate),
        },
        {
            title: 'NET',
            dataIndex: 'NET',
            key: 'NET',
            sorter: (a, b) => a.NET.localeCompare(b.NET),
            render(text) {
                return (
                    <div className="flex justify-between">
                        <p>Rp</p> <p>{formatRupiah(text)}</p>
                    </div>
                )
            }
        },
    ];

    const [searchText, setSearchText] = useState('');
    const [data, setData] = useState([]);

    useEffect(() => {
        if (dataSource && dataSource.length > 0) {
            setData(dataSource);
        }
    }, [dataSource]);


    const handleSearch = (e) => {
        setSearchText(e.target.value);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some((val) =>
            val && val.toString().toLowerCase().includes(searchText.toLowerCase())
        )
    );

    return (
        <div className="flex flex-col w-full">
            <div className="flex justify-end mb-2">
                <SearchInput value={searchText} onChange={handleSearch} />
            </div>
            <Table
                columns={columns}
                dataSource={filteredData}
                scroll={{
                    x: 'max-content',
                }}
            />
        </div >
    )
}

export default TableInvoice